<div class="dual-list d-flex  mt-1">
  <div class="col-md-5 dual-list-left">
    <div class="listbox w-100">

      @if (filter) {
        <form class="filter">
          <input class="form-control" name="filterSource" [(ngModel)]="available.picker"
            (ngModelChange)="onFilter(available)">
          </form>
        }

        <div class="record-picker">
          <h4>Available Roles</h4>
          <ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:available.dragOver}"
            (drop)="drop($event, confirmed)" (dragover)="allowDrop($event, available)"
            (dragleave)="dragLeave()">
            @for (item of available.sift; track item; let idx = $index) {
              <li
                (click)="disabled ? null : selectItem(available.pick, item); shiftClick($event, idx, available, item)"
                [ngClass]="{selected: isItemSelected(available.pick, item), disabled: disabled}"
                [draggable]="!disabled && format.draggable" (dragstart)="drag($event, item, available)"
                (dragend)="dragEnd(available)"><label>{{item._name}}</label></li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-2 arrow-btn-sec">
        <button class="move-right-btn" type="button" name="addBtn" (click)="moveItem(available, confirmed)"
          [ngClass]="direction() ? 'point-right' : 'point-left'" [disabled]="available.pick.length === 0">
          <!-- {{format.add}} -->
          <img src="../../../../assets/icons/right.png" />
        </button>
        <button class="move-left-btn" type="button" name="removeBtn" (click)="moveItem(confirmed, available)"
          [ngClass]="direction() ? 'point-left' : 'point-right'" [disabled]="confirmed.pick.length === 0">
          <!-- {{format.remove}} -->
          <img src="../../../../assets/icons/left.png" />
        </button>


      </div>
      <div class="col-md-5 d-flex dual-list-right">
        <div class="listbox w-100"
          [ngStyle]="{ 'order' : direction() ? 2 : 1, 'margin-left' : direction() ? '0px' : 0 }">


          @if (filter) {
            <form class="filter">
              <input class="form-control" name="filterDestination" [(ngModel)]="confirmed.picker"
                (ngModelChange)="onFilter(confirmed)">
              </form>
            }

            <div class="record-picker ht-100">
              <h4>Assigned Roles</h4>
              <ul [ngStyle]="{'max-height': height, 'min-height': height}" [ngClass]="{over:confirmed.dragOver}"
                (drop)="drop($event, available)" (dragover)="allowDrop($event, confirmed)"
                (dragleave)="dragLeave()">
                @for (item of confirmed.sift; track item; let idx = $index) {
                  <li #itmConf
                    (click)="disabled ? null : selectItem(confirmed.pick, item); shiftClick($event, idx, confirmed, item)"
                    [ngClass]="{selected: isItemSelected(confirmed.pick, item), disabled: disabled}"
                    [draggable]="!disabled && format.draggable" (dragstart)="drag($event, item, confirmed)"
                    (dragend)="dragEnd(confirmed)"><label>{{item._name}}</label></li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>